export default "__VITE_ASSET__vNKS9BXew4q2HmjGm8GLsQ__"